// Omnix/client/ui/FilterDropdown.js
import { ComponentBase } from "../core/ComponentBase.js";

export class FilterDropdown extends ComponentBase {
    static styles = `
        .filter-dropdown .dropdown-toggle {
            color: var(--bs-secondary-color);
            transition: all 0.2s ease-in-out;
        }
        .filter-dropdown .dropdown-toggle.active {
            color: var(--bs-primary);
            background-color: var(--bs-primary-bg-subtle);
        }
        .filter-dropdown .dropdown-toggle:hover {
            color: var(--bs-primary);
        }
        .filter-dropdown .dropdown-menu {
            min-width: 220px;
            max-height: 300px;
            overflow-y: auto;
        }
        .filter-dropdown .dropdown-item {
            display: flex;
            align-items: center;
            gap: 0.75rem;
        }
        .filter-dropdown .dropdown-item i {
            width: 1.2rem;
            text-align: center;
        }
    `;

    constructor(config) {
        super(config);
        this.title = this.config.title;
        this.icon = this.config.icon;
        this.options = this.config.options || [];
        this.activeValue = this.config.activeValue;
        this.applyStyles();
    }

    updateOptions(newOptions, newActiveValue) {
        this.options = newOptions;
        this.activeValue = newActiveValue;
        if (this.container) this.render();
    }

    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'filter-dropdown dropdown';
        }
        this.container.innerHTML = '';

        const isActive = this.activeValue !== null && this.activeValue !== undefined && this.activeValue !== '';
        const button = document.createElement('button');
        button.className = `btn btn-sm dropdown-toggle ${isActive ? 'active' : ''}`;
        button.type = 'button';
        button.title = this.t(this.title);
        button.setAttribute('data-bs-toggle', 'dropdown');
        button.setAttribute('aria-expanded', 'false');
        button.innerHTML = `<i class="bi ${this.icon}"></i>`;

        const menu = document.createElement('ul');
        menu.className = 'dropdown-menu';

        // Add "All" / "Clear" option
        const allOption = document.createElement('li');
        const allLink = document.createElement('a');
        allLink.className = `dropdown-item ${!isActive ? 'active' : ''}`;
        allLink.href = '#';
        allLink.innerHTML = `<i class="bi bi-x-circle"></i> <span>${this.t('All')} ${this.t(this.title)}</span>`;
        allLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.emit('change', { value: null });
        });
        allOption.appendChild(allLink);
        menu.appendChild(allOption);
        menu.appendChild(document.createElement('li')).innerHTML = '<hr class="dropdown-divider">';

        // Add specific options
        this.options.forEach(option => {
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.className = `dropdown-item ${this.activeValue === option.value ? 'active' : ''}`;
            link.href = '#';
            link.innerHTML = `${option.icon ? `<i class="bi ${option.icon}"></i>` : '<i class="bi"></i>'} <span>${this.t(option.label)}</span>`;
            link.addEventListener('click', (e) => {
                e.preventDefault();
                this.emit('change', { value: option.value });
            });
            item.appendChild(link);
            menu.appendChild(item);
        });

        this.container.appendChild(button);
        this.container.appendChild(menu);
        return this.container;
    }
}